function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M149.07843,674.20215l43.07664-68.361-43.09661,75.80813-.02309,7.7894q-4.60974-.0539-9.12643-.35342l3.51352-100.06285-.0462-.77342.07916-.14767.33455-9.45528L98.74955,503.72254l45.08688,67.8427.1349,2.00269,2.65414-75.6014-38.7204-77.518,39.023,64.23377,1.8152-156.70073.00832-.52151.00624.51318.88382,123.54783,36.99947-49.43346L149.60894,462.1622l-.17171,67.668,34.33009-65.354-34.349,75.30247-.095,37.62683,49.86758-90.99615L149.284,590.5318Z",
  transform: "translate(-98.74955 -191.88988)",
  fill: "#d0cde1"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 642.85096,
  y: 193.7674,
  width: 12.11046,
  height: 85.98428,
  fill: "#3f3d56"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 521.32907,
  y: 57.40029,
  width: 12.11046,
  height: 483.65711,
  transform: "translate(-46.96838 483.46895) rotate(-67.90849)",
  fill: "#3f3d56"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M1101.24876,685.58308C1082.49147,716.92037,97.76,714.2897,99.25214,685.58122,118.00918,654.24579,1102.7407,656.87647,1101.24876,685.58308Z",
  transform: "translate(-98.74955 -191.88988)",
  fill: "#d0cde1"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 773.64395,
  y: 366.94701,
  width: 105.36102,
  height: 41.17557,
  fill: "#3f3d56"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 349.77776,
  y: 403.2784,
  width: 519.53884,
  height: 46.01976,
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  points: "783.938 426.288 659.2 426.288 659.2 269.458 752.451 269.458 783.938 348.555 783.938 426.288",
  fill: "#d0cde1"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 678.57682,
  y: 279.14616,
  width: 53.28603,
  height: 53.28603,
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  points: "771.827 333.038 737.918 333.038 737.918 279.752 752.451 279.752 771.827 333.038",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 680.99891,
  y: 362.70835,
  width: 12.11046,
  height: 23.00988,
  fill: "#3f3d56"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M748.212,313.661h.60553a11.50493,11.50493,0,0,1,11.50493,11.50493v0a11.50493,11.50493,0,0,1-11.50493,11.50493H748.212a0,0,0,0,1,0,0V313.661a0,0,0,0,1,0,0Z",
  fill: "#3f3d56"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M297.70277,403.2784h.60553a11.50493,11.50493,0,0,1,11.50493,11.50493v0a11.50493,11.50493,0,0,1-11.50493,11.50493h-.60553a0,0,0,0,1,0,0V403.2784A0,0,0,0,1,297.70277,403.2784Z",
  fill: "#3f3d56"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M931.12924,594.99452c18.45486,0,35.05463,8.94049,46.5728,23.18364h23.66789l-23.00988-64.09594-107.1776-21.138,3.02762,85.234h10.34637C896.07461,603.935,912.67439,594.99452,931.12924,594.99452Z",
  transform: "translate(-98.74955 -191.88988)",
  fill: "#d0cde1"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 833.59074,
  cy: 441.42636,
  r: 52.68051,
  fill: "#3f3d56"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 833.59074,
  cy: 441.42636,
  r: 27.72659,
  fill: "#d0cde1"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 357.64956,
  cy: 447.48159,
  r: 46.01976,
  fill: "#3f3d56"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 357.64956,
  cy: 447.48159,
  r: 24.22092,
  fill: "#d0cde1"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 637.40125,
  y: 247.65896,
  width: 25.43197,
  height: 183.47351,
  fill: "#3f3d56"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 297.09725,
  y: 397.82869,
  width: 365.73597,
  height: 10.89942,
  fill: "#3f3d56"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 194.30308,
  y: 575.27158,
  width: 413.35786,
  height: 10.89942,
  transform: "translate(-237.13545 -66.25763) rotate(-15.21949)",
  fill: "#3f3d56"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 585.08165,
  y: 530.05667,
  width: 8.47732,
  height: 70.85626,
  transform: "translate(-319.17476 266.90058) rotate(-36.31135)",
  fill: "#3f3d56"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  x: 743.36779,
  y: 335.45981,
  width: 12.11046,
  height: 4.84418,
  fill: "#3f3d56"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M747.65574,563.68108H589.00868a1.21092,1.21092,0,0,1-.34416-2.37183l155.01392-46.01976a1.21074,1.21074,0,0,1,1.55166,1.06558l3.63314,46.01976a1.21143,1.21143,0,0,1-1.2075,1.30625ZM597.3429,561.259H746.34535l-3.412-43.22217Z",
  transform: "translate(-98.74955 -191.88988)",
  fill: "#3f3d56"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M318.04891,510.395h-.01124l-34.76613-.3276a1.2112,1.2112,0,0,1-1.19213-1.34882l18.064-157.61519a1.21146,1.21146,0,0,1,1.20336-1.07326h.00532a1.21158,1.21158,0,0,1,1.19922,1.08391l16.70215,157.94278a1.21129,1.21129,0,0,1-1.20454,1.33818Zm-33.40962-2.73668,32.06257.30158L301.29827,362.2997Z",
  transform: "translate(-98.74955 -191.88988)",
  fill: "#3f3d56"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M970.48825,556.4148h.60553a11.50493,11.50493,0,0,1,11.50493,11.50493v0a11.50493,11.50493,0,0,1-11.50493,11.50493h-.60553a0,0,0,0,1,0,0V556.4148A0,0,0,0,1,970.48825,556.4148Z",
  transform: "translate(1992.09742 561.76549) rotate(159.28262)",
  fill: "#3f3d56"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 215.94814,
  y: 588.22581,
  width: 35.08027,
  height: 5.5683,
  transform: "translate(-249.4105 -107.08039) rotate(-15.63709)",
  fill: "#3f3d56"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M494.25243,516.57572l-6.5206,3.55983L222.83891,594.27986l-3.93276-4.88514a58.17112,58.17112,0,0,1-12.58107-29.144c-1.00026-7.98461-.26866-16.40044,5.30138-21.52286l-10.11625-81.59017,146.50027-41.20421,69.48493,29.899s26.616-7.953,46.20245,6.08c6.19992,4.44595,11.698,11.09472,15.416,20.90745l3.20251,9.25159Z",
  transform: "translate(-98.74955 -191.88988)",
  fill: "current"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 336.94773,
  cy: 339.63002,
  r: 33.96661,
  fill: "#3f3d56"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 336.94773,
  cy: 339.63002,
  r: 17.87716,
  fill: "#d0cde1"
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 175.54536,
  cy: 384.80702,
  r: 33.96661,
  fill: "#3f3d56"
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 175.54536,
  cy: 384.80702,
  r: 17.87716,
  fill: "#d0cde1"
});

var _ref33 = /*#__PURE__*/React.createElement("polygon", {
  points: "294.724 254.884 189.624 284.302 180.769 252.665 247.797 233.903 294.724 254.884",
  fill: "#fff"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 228.44813,
  y: 453.4022,
  width: 43.43272,
  height: 32.85295,
  transform: "translate(-216.12969 -107.07056) rotate(-15.63709)",
  fill: "#fff"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  x: 296.30078,
  y: 498.83899,
  width: 5.5683,
  height: 10.57976,
  transform: "translate(-223.56445 -92.61487) rotate(-15.63709)",
  fill: "#3f3d56"
});

var _ref36 = /*#__PURE__*/React.createElement("rect", {
  x: 377.63635,
  y: 457.85865,
  width: 5.5683,
  height: 10.57976,
  transform: "translate(625.13777 -219.92039) rotate(74.36291)",
  fill: "#3f3d56"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M375.62632,438.70629h.61252A11.63773,11.63773,0,0,1,387.87657,450.344v0a11.63773,11.63773,0,0,1-11.63773,11.63773h-.61252a0,0,0,0,1,0,0V438.70629A0,0,0,0,1,375.62632,438.70629Z",
  transform: "translate(-206.00747 -72.32334) rotate(-15.63709)",
  fill: "#3f3d56"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M482.31639,482.07146a17.98812,17.98812,0,0,1-18.61853-30.159c6.19992,4.44595,11.698,11.09472,15.416,20.90745Z",
  transform: "translate(-98.74955 -191.88988)",
  fill: "#3f3d56"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 195.97489,
  y: 10.89942,
  width: 12.11046,
  height: 176.81275,
  fill: "#3f3d56"
});

var _ref40 = /*#__PURE__*/React.createElement("circle", {
  cx: 202.03012,
  cy: 16.95465,
  r: 16.95465,
  fill: "#3f3d56"
});

var _ref41 = /*#__PURE__*/React.createElement("circle", {
  cx: 648.90619,
  cy: 196.18949,
  r: 16.95465,
  fill: "#3f3d56"
});

function SvgTowing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bf6b072d-b0c7-410f-9e86-e550d19ff3f5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1002.5009,
    height: 516.22024,
    viewBox: "0 0 1002.5009 516.22024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "towing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowing);
export default __webpack_public_path__ + "static/media/towing.32992b32.svg";
export { ForwardRef as ReactComponent };